var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "toggle" }, [
    _c(
      "div",
      {
        staticClass: "toggle-inner",
        on: {
          click: function ($event) {
            if ($event.target !== $event.currentTarget) return null
            return _vm.onClick.apply(null, arguments)
          },
        },
      },
      [
        _c("div", {
          staticClass: "draggable",
          class: {
            "draggable--savings": _vm.showPotenitialSavings,
            "draggable--empty": _vm.isAnswerEmpty,
          },
          style: _vm.style,
          on: {
            mousedown: function ($event) {
              $event.preventDefault()
              return _vm.dragStart.apply(null, arguments)
            },
            touchstart: function ($event) {
              $event.preventDefault()
              return _vm.dragStart.apply(null, arguments)
            },
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }